

























import {Component, Vue, Watch, Prop} from "vue-property-decorator";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {LadingStore} from "@/modules/ladings/store";
import debounce from "lodash/debounce";
import {LadingParams} from "@/modules/ladings/params";
import CustomerSelector from "@/shared/components/CustomerSelector/index.vue";
import EmployeeSelector from "@/shared/components/EmployeeSelector/index.vue";
import {LadingStatus} from "@/enums/status";

@Component({
  name: "LadingSearchForUpdate",
  components: {EmployeeSelector, CustomerSelector, EnumSelector}
})
export default class extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isViewUpdate!: boolean;
  form = new LadingParams();
  LadingStatus = LadingStatus;
  limitStatus = [
    LadingStatus.NhapKhoChoCapNhat,
    LadingStatus.LayHangThanhCongChoCapNhat,
    LadingStatus.ChoCapNhat,
  ];

  @Watch('form', {immediate: false, deep: true})
  onValuesChange(val: any) {
    this.handleChange(val, this);
  }

  handleChange = debounce(function (val, vm) {
    LadingStore.updateLadingParams({...LadingStore.params, ...val});
    if (vm.isViewUpdate) {
      LadingStore.listLadingNeedUpdate({...LadingStore.params, page: 1});
    } else {
      LadingStore.listLading({...LadingStore.params, page: 1});
    }
  }, 500);
}
